// @flow

import * as React from "react";

import "./PageTitle.scss";

type Props = {
    children: React.Node
};

export default class PageTitle extends React.PureComponent<Props> {
    render() {
        return <h2 className="PageTitle">{this.props.children}</h2>;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/PageTitle/PageTitle.js